export default (
  state = {
    attributes: [],
    formFields: [],
    metaData: {},
    pricelist: [],
    products: [],
    users: [],
    workflowDetails: {},
    workflowList: [],
  },
  action,
) => {
  switch (action.type) {
    case "UPDATE_WORKFLOW_LIST":
      return { ...state, workflowList: action.payload };
    case "REACTION_WORKFLOW_INIT_DATA":
      return {
        ...state,
        attributes: action.payload.attributes,
        formFields: action.payload.formFields,
        metaData: action.payload.metaData,
        pricelist: action.payload.pricelists,
        products: action.payload.products,
        users: action.payload.users,
        userGroups: action.payload.userGroups,
        workflowDetails: action.payload.workflowData,
      };
    case "UPDATE_WORKFLOW_RULE":
      return {
        ...state,
        workflowDetails: {
          ...state.workflowDetails,
          rules: action.payload.workflowData,
        },
        formFields: action.payload.formFields,
      };
    case "UPDATE_WORKFLOW_FORMFIELDS":
      return {
        ...state,
        formFields: action.payload,
      };

    case "NUKE_WORKFLOW_FORMFIELDS":
      return {
        ...state,
        formFields: action.payload,
      };
    default:
      return state;
  }
};
